export const SCREEN_RESIZE = 'SCREEN_RESIZE';
export const SET_DRAWER_OPEN = 'SET_DRAWER_OPEN';

export const screenResize = (width, height) => ({
  type: SCREEN_RESIZE,
  width,
  height
});

/**
 * Open or close the navigation drawer. Only meaningful below RAIL_WIDTH — at
 * or above it the rail is always visible and the drawer is never mounted.
 *
 * @param {boolean} open
 */
export const setDrawerOpen = (open) => ({
  type: SET_DRAWER_OPEN,
  open
});
